import _toConsumableArray from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var NAVIGATION_ENTRY_KEYS = ['name', 'type', 'startTime', 'transferSize', 'duration'];

function isNavigationEntryEqual(a) {
  return function (b) {
    return NAVIGATION_ENTRY_KEYS.every(function (key) {
      return a[key] === b[key];
    });
  };
}
/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */
// TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type


function dedupePerformanceEntries(currentList, newList) {
  // Partition `currentList` into 3 different lists based on entryType
  var _currentList$reduce = currentList.reduce(function (acc, entry) {
    if (entry.entryType === 'navigation') {
      acc[0].push(entry);
    } else if (entry.entryType === 'largest-contentful-paint') {
      acc[1].push(entry);
    } else {
      acc[2].push(entry);
    }

    return acc;
  }, [[], [], []]),
      _currentList$reduce2 = _slicedToArray(_currentList$reduce, 3),
      existingNavigationEntries = _currentList$reduce2[0],
      existingLcpEntries = _currentList$reduce2[1],
      existingEntries = _currentList$reduce2[2];

  var newEntries = [];
  var newNavigationEntries = [];
  var newLcpEntry = existingLcpEntries.length ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
  : undefined;
  newList.forEach(function (entry) {
    if (entry.entryType === 'largest-contentful-paint') {
      // We want the latest LCP event only
      if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) {
        newLcpEntry = entry;
      }

      return;
    }

    if (entry.entryType === 'navigation') {
      var navigationEntry = entry; // Check if the navigation entry is contained in currentList or newList

      if ( // Ignore any navigation entries with duration 0, as they are likely duplicates
      entry.duration > 0 && // Ensure new entry does not already exist in existing entries
      !existingNavigationEntries.find(isNavigationEntryEqual(navigationEntry)) && // Ensure new entry does not already exist in new list of navigation entries
      !newNavigationEntries.find(isNavigationEntryEqual(navigationEntry))) {
        newNavigationEntries.push(navigationEntry);
      } // Otherwise this navigation entry is considered a duplicate and is thrown away


      return;
    }

    newEntries.push(entry);
  }); // Re-combine and sort by startTime

  return [].concat(_toConsumableArray(newLcpEntry ? [newLcpEntry] : []), _toConsumableArray(existingNavigationEntries), _toConsumableArray(existingEntries), newEntries, newNavigationEntries).sort(function (a, b) {
    return a.startTime - b.startTime;
  });
}

export { dedupePerformanceEntries };